import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { type Visit, type Vitals } from "../graphql/generated";

//file where i can store the visitState and the vitals state

export interface VisitState {
  visit?: Visit;
  vitals?: Vitals;
}

const initialState: VisitState = {};
// const initialState: VisitState = {
//   visit: {
//     visitId: "11",
//     originalNotes: "You have a cold",
//   }
// };

interface SetVisitParams {
  visit?: Visit;
  vitals?: Vitals;
}

const visitSlice = createSlice({
  name: "Visit",
  initialState,
  reducers: {
    setVisit: (state, action: PayloadAction<SetVisitParams>) => {
      //commented out for debugging the current visit slice.
      console.log(
        `Set visit is called payload ${JSON.stringify(action.payload)}`
      );
      state.visit = action.payload.visit;
      state.vitals = action.payload.vitals;
    },
  },
});

export default visitSlice.reducer;
export const { setVisit } = visitSlice.actions;
